import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Util from '../../script/util';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import * as Map from 'immutable';

class TjOrder extends Component {
  //验证是否更新
  shouldComponentUpdate(newProps, newState) {
    const props1 = Map.fromJS(newProps.godUser);
    const props2 = Map.fromJS(this.props.godUser);
    const bool = Map.is(props1, props2);
    const props11 = Map.fromJS(newProps.orderNum);
    const props21 = Map.fromJS(this.props.orderNum);
    const bool1 = Map.is(props11, props21);
    if (!bool || !bool1) {
      return true;
    } else {
      return false;
    }
  }
  //下单
  addDsOrder = () => {
    const { godUser, base } = this.props;
    let cat = null;
    if (godUser && godUser.godCategoryList && godUser.godCategoryList.length) {
      if (base.webim && base.webim.jnid) {
        let cats = godUser.godCategoryList.filter(
          (item) => item.categoryId == base.webim.jnid
        );
        if (cats && cats.length > 0) {
          cat = cats[0];
        } else {
          cat = godUser.godCategoryList[0];
        }
      } else {
        cat = godUser.godCategoryList[0];
      }
    }
    if (cat) {
      this.props.addDsOrder({
        dsid: cat.uid,
        jnid: cat.categoryId,
        num:
          cat.fullGiveStutas && !this.props.hasGivefull
            ? 3
            : this.props.orderNum,
        ehot: false,
      });
    }
  };
  diamondPrice = (price) => {
    return (
      <div className="d-price">
        {price * 100}
        <span className="d-icon"></span>
      </div>
    );
  };
  render() {
    const { godUser, orderNum, base } = this.props;
    let cat = null;
    if (godUser && godUser.godCategoryList && godUser.godCategoryList.length) {
      if (base.webim && base.webim.jnid) {
        let cats = godUser.godCategoryList.filter(
          (item) => item.categoryId == base.webim.jnid
        );
        if (cats && cats.length > 0) {
          cat = cats[0];
        } else {
          cat = godUser.godCategoryList[0];
        }
      } else {
        cat = godUser.godCategoryList[0];
      }
    }
    return (
      <div className="top-tj-order noSelect">
        <div className="border-plan fadeInDown animated faster">
          {cat ? (
            <div className="order-bg">
              <div className="c-cover">
                <img alt="" src={Util.transImgUrl(cat.icon)} />
              </div>
              <span className="c-name">{cat.categoryName}</span>
              {cat?.level && <span className="c-level">{cat.level}</span>}
              <div className="c-price">
                <span className="p1">
                  {base.rootConfig.lang == 'zh_CN' && (
                    <label>
                      ￥<b>{cat.price}</b>
                    </label>
                  )}
                  {base.rootConfig.lang != 'zh_CN' && (
                    <label>{this.diamondPrice(cat.price)}</label>
                  )}
                  /{cat.unit}
                </span>
              </div>
              <span
                className={
                  cat.fullGiveStutas && !this.props.hasGivefull
                    ? 'number-box has-full'
                    : 'number-box'
                }
              >
                {/* 买2送1 */}
                {cat.fullGiveStutas && !this.props.hasGivefull ? (
                  <label className="full-give-ban"></label>
                ) : null}
                <span
                  className="num-del"
                  onClick={this.props.changeNum.bind(this, -1)}
                >
                  <MinusOutlined />
                </span>
                <span className="num-tt">{orderNum}</span>
                <span
                  className="num-add"
                  onClick={this.props.changeNum.bind(this, 1)}
                >
                  <PlusOutlined />
                </span>
              </span>
              <button className="daidai-btn-primary" onClick={this.addDsOrder}>
                立即下单
              </button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(TjOrder, { withRef: true });
